import React from 'react';
import * as S from '../../ChooseBrandsModels.styled';
import { CheckTreeDivided } from 'assets/icons';
import { Checkbox } from 'components';
import Hightlighter from 'react-highlight-words';

const ModelItem = ({ search, counter, model, onChange, isChecked }) => {
  return (
    <S.ChooseItemRow>
      <S.Wrap>
        <CheckTreeDivided />
        <Checkbox
          id={counter.toString()}
          isChecked={isChecked}
          name={model}
          style={{ marginRight: '16px' }}
          onChange={onChange}
        />
        <S.ItemName>
          <Hightlighter textToHighlight={model} searchWords={[search]} highlightTag='strong' />
        </S.ItemName>
      </S.Wrap>
      <S.ItemNameMarker>
        <span>Model</span>
      </S.ItemNameMarker>
    </S.ChooseItemRow>
  );
};

export default ModelItem;
